module.exports = __webpack_public_path__ + "img/brave-1.e81d9154.webp";